import { TrialContext } from "@/contexts/data/TrialContext";
import { TrialInstitutionCoordinatorsContext } from "@/contexts/data/TrialInstitutionCoordinatorsContext";
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogProps, FormControlLabel, FormGroup, Typography } from "@mui/material";
import { totalmem } from "os";
import { ChangeEvent, Dispatch, FC, SetStateAction, useContext, useEffect, useMemo, useState } from "react";

interface ITrialCoordinatorSelectDialogProps extends DialogProps {
    setDialogOpen: Dispatch<SetStateAction<boolean>>,
    onAfterClose: (trialCoordinatorIds: number[]) => void
}

const TrialCoordinatorSelectDialog: FC<ITrialCoordinatorSelectDialogProps> = ({
    open,
    setDialogOpen,
    onAfterClose
}) => {
    const {data: trial} = useContext(TrialContext);
    const [selectedOptions, setSelectedOptions] = useState<number[]>([]);

    const {data: coordinatorOptions} = useContext(TrialInstitutionCoordinatorsContext);

    useEffect(() => {
        setSelectedOptions([]);
    }, [coordinatorOptions])

    const handleCheckboxChange = (option: number, checked: boolean) => {
        if(!checked) {
            setSelectedOptions(old => old.filter(selectedOption => selectedOption != option));
        } 
        else {
            setSelectedOptions(old => [...old, option]);
        }
    }

    const coordinatorCheckboxes = useMemo(() => (
        <FormGroup>
            {
                coordinatorOptions?.map((option, index) => {   
                    return (
                        <FormControlLabel
                            key={index}
                            control={
                                <Checkbox
                                    key={index} 
                                    checked={selectedOptions.includes(option.id!)}
                                    onChange={(_event, checked) => handleCheckboxChange(option.id!, checked)}
                                />
                            }
                            label={`${option.firstName} ${option.lastName}`}
                        />
                    );
                })
            }
        </FormGroup>
    ), [coordinatorOptions, selectedOptions]);
    
    const handleClose = () => {
        setDialogOpen(false);
        onAfterClose(selectedOptions);
    }

    return (
        <Dialog 
            open={open}
            maxWidth={"sm"}
            fullWidth
            onClose={() => setDialogOpen(false)}
        >
            <DialogContent>
                {
                    coordinatorOptions && coordinatorOptions?.length > 0 
                        ? coordinatorCheckboxes 
                        :
                            <Typography>
                                No trial coordinators exist for this site in {trial?.name}.
                            </Typography>
                }
                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={handleClose}
                        disabled={
                            !coordinatorOptions || 
                            coordinatorOptions.length == 0 ||
                            selectedOptions.length == 0
                        }
                    >
                        Send Emails
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
}

export default TrialCoordinatorSelectDialog;